import { render, staticRenderFns } from "./UsersProcessAdmin.vue?vue&type=template&id=79917bbf&scoped=true&"
import script from "./UsersProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./UsersProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UsersProcessAdmin.vue?vue&type=style&index=0&id=79917bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79917bbf",
  null
  
)

export default component.exports